import { Metrika } from '../../lib/classes';
// import {test20percent} from './../../test20percent'
export function metrika(onload) {
    var METRIKA_COUNTER_ID = COUNTER_ID;
    // if (FOR_VK && test20percent()) METRIKA_COUNTER_ID = '89795637'
    Metrika.init(METRIKA_COUNTER_ID, onload);
}
